module.exports = __webpack_public_path__ + "assets/img/31e04de2a6687bfac42de1f6553aac70.png";